import { render, staticRenderFns } from "./VDependency.vue?vue&type=template&id=f5115f50&"
import script from "./VDependency.vue?vue&type=script&lang=js&"
export * from "./VDependency.vue?vue&type=script&lang=js&"
import style0 from "./VDependency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports